<template>
  <div class="r-slider">
    <r-text
      v-if="title"
      color-type="subhead"
    >
      {{ title }}
    </r-text>
    <div
      class="r-slider__wrapper"
      :class="{ 'no-input': noInput }"
    >
      <input
        v-model="input"
        type="range"
        :style="{ backgroundSize: interval }"
        :min="min"
        :max="max"
        :disabled="disabled"
        :step="step"
        @input="updateInput"
      />
      <r-input-number
        v-if="!noInput"
        v-model="input"
        :min="min"
        :max="max"
        :disabled="disabled"
        mini
        :step="step"
        controls="right"
        class="r-slider__input"
        @input="updateInput"
      />
    </div>
  </div>
</template>

<script>
import { throttle } from 'HELPERS'
import { ref, computed } from 'vue'

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      default: 0
    },
    noInput: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 9
    },
    step: {
      type: Number,
      default: 1
    }
  },
  setup({ min, max, value }, { emit }) {
    const input = ref(value)
    const interval = computed(() => {
      return ((input.value - min) * 100) / (max - min) + '% 100%'
    })

    const updateInput = function (e) {
      let val = e

      if (typeof e === 'object') {
        let target = e.target
        if (e.target.type !== 'range') {
          target = document.getElementById('range')
        }

        val = +target.value
      }

      return throttle(emit('change', +val), 250)
    }

    return {
      input,
      interval,

      updateInput
    }
  }
}
</script>

<style lang="scss" scoped>
.r-slider {
  display: grid;
  grid-gap: 0.25rem;
  width: 100%;

  &__wrapper {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 1fr auto;
    align-items: center;

    &.no-input {
      grid-template-columns: auto;
    }
  }

  &__input {
    width: 100px;
  }

  @mixin thumb {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background: $accent-primary;
  }

  input[type='range']:not([disabled]):active::-webkit-slider-thumb {
    cursor: grabbing;
  }

  input[type='range']:not([disabled]):active::-moz-range-thumb {
    cursor: grabbing;
  }

  input[type='range'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    height: 2px;
    background-color: $dividers-low-contrast;
    border-radius: 0.25rem;
    background-image: linear-gradient($accent-primary, $accent-primary);
    background-repeat: no-repeat;
    cursor: pointer;
  }

  input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none;
    @include thumb;
    cursor: grab;
  }

  input[type='range']::-moz-range-thumb {
    -moz-appearance: none;
    border: none;
    @include thumb;
    cursor: grab;
  }

  input[disabled],
  input[disabled]::-webkit-slider-thumb {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
